import { Link } from "react-router-dom";

const price = "119";
const excenge = "Art Festival Special Offer";
const paymentTitle = "Secure Payment Options:";
const shareTitle = "Share This Art Course:";
const btnText = "Enroll Now";

const csdcList = [
    {
        iconName: 'icofont-ui-alarm',
        leftText: 'Course Level',
        rightText: 'Beginner to Intermediate',
    },
    {
        iconName: 'icofont-book-alt',
        leftText: 'Course Duration',
        rightText: '6 Weeks',
    },
    {
        iconName: 'icofont-signal',
        leftText: 'Live Online Classes',
        rightText: '06',
    },
    {
        iconName: 'icofont-video-alt',
        leftText: 'Recorded Lessons',
        rightText: '15 Videos',
    },
    {
        iconName: 'icofont-abacus-alt',
        leftText: 'Practice Assignments',
        rightText: '08',
    },
    {
        iconName: 'icofont-hour-glass',
        leftText: 'Project Submission',
        rightText: 'Required',
    },
    {
        iconName: 'icofont-certificate',
        leftText: 'Certificate',
        rightText: 'Yes – After Completion',
    },
    {
        iconName: 'icofont-globe',
        leftText: 'Course Language',
        rightText: 'English / Hindi',
    },
];

const socialList = [
    {
        siteLink: '#',
        iconName: 'icofont-twitter',
        className: 'twitter',
    },
    {
        siteLink: '#',
        iconName: 'icofont-vimeo',
        className: 'vimeo',
    },
    {
        siteLink: '#',
        iconName: 'icofont-rss',
        className: 'rss',
    },
];

const CourseSideDetail = () => {
    return (
        <div className="course-side-detail">
            <div className="csd-title">
                <div className="csdt-left">
                    <h4 className="mb-0"><sup>$</sup>{price}</h4>
                </div>
                <div className="csdt-right">
                    <p className="mb-0"><i className="icofont-clock-time"></i>{excenge}</p>
                </div>
            </div>
            <div className="csd-content" style={{ color: "black" }} >
                <div className="csdc-lists">
                    <ul className="lab-ul">
                        {csdcList.map((val, i) => (
                            <li key={i}>
                                <div className="csdc-left"><i className={val.iconName}></i>{val.leftText}</div>
                                <div className="csdc-right">{val.rightText}</div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="sidebar-payment">
                    <div className="sp-title">
                        <h6>{paymentTitle}</h6>
                    </div>
                    <div className="sp-thumb">
                        <img src="assets/images/pyment/01.jpg" alt="CodexCoder" />
                    </div>
                </div>

                <div className="sidebar-social">
                    <div className="ss-title">
                        <h6>{shareTitle}</h6>
                    </div>
                    <div className="ss-content">
                        <ul className="lab-ul">
                            {socialList.map((val, i) => (
                                <li key={i}><a href={val.siteLink} className={val.className}><i className={val.iconName}></i></a></li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="course-enroll">
                    <Link to="/signup" className="lab-btn"><span>{btnText}</span></Link>
                </div>
            </div>
        </div>
    );
}

export default CourseSideDetail;
